"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uiTheme = require("@kyruus/ui-theme");
var _BasicFadingLinesSpinner = _interopRequireDefault(require("../BasicFadingLinesSpinner"));
const FadingLinesSpinner = _ref => {
  let {
    size = 'small',
    color = undefined,
    ...restProps
  } = _ref;
  color = color || (0, _uiTheme.fromTheme)('color_kyruus')(restProps || {});
  return /*#__PURE__*/_react.default.createElement(_BasicFadingLinesSpinner.default, {
    spinnerSize: size,
    spinnerColor: color
  });
};
FadingLinesSpinner.propTypes = {
  /**
   * Controls the size of the spinner
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  /**
   * Controls the color of the spinner
   */
  color: _propTypes.default.string
};
var _default = exports.default = FadingLinesSpinner;
FadingLinesSpinner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FadingLinesSpinner",
  "props": {
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "description": "Controls the size of the spinner",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false
    },
    "color": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Controls the color of the spinner",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};